export const validateCfForImport = async (cf, environment, adeApi, anagraficaApi) => {
    if (!cf) return true;
    if (environment === "PROD") {
        const res = await adeApi.validateCFFromADE(cf);
        return res ? res.valido : true;
    }
    return await anagraficaApi.VerifyCf(cf);
};

export const validatePivaForImport = async (pIva, environment, adeApi, anagraficaApi) => {
    if (!pIva) return true;
    if (environment === "PROD") {
        const res = await adeApi.validatePIVAFromADE(pIva);
        return res ? res.valida : true;
    }
    return await anagraficaApi.VerifyPIva(pIva);
};
